<template>
  <div id="Task-edit">

    <IForm :label-width="110" ref="formInline" :model="edit" :elem="taskElem" :rules="taskRule" @on-submit="toSubmit" :submit="false" :showMessage="true">
      <div slot="extend">
          <Row>
            <Col span="8">
              <Row>
                <Col span="24">
                  <FormItem label="任务名称" prop="name">
                    <Input v-model.trim="edit.name" type="text" placeholder="请输入任务名称" maxlength="50" :disabled="disabled"/>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <FormItem label="预计体检日期" prop="physicalDate">
                    <DatePicker :value="edit.physicalDate" :editable="false" @on-change="changePhysicalDate"
                                type="date" format="yyyy-MM-dd" placeholder="预计体检日期" :disabled="disabled" style="width: 100%;"/>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <FormItem label="体检人群" prop="crowdIds">
                    <Select v-model="edit.crowdIds" :multiple="true" :disabled="disabled">
                      <Option v-for="item in crowdList" :value="item.id" v-bind:key="item.id">{{ item.name }}</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <FormItem  label="体检学校"  prop="schoolId">
                    <el-select v-model.trim="edit.schoolId" placeholder="体检地点"
                               clearable filterable size="small" transfer="true"
                               :popper-append-to-body="false" :disabled="disabled" style="width: 100%;">
                      <el-option v-for="item in schoolsList" :key="item.id" :label="item.name" :value="item.id"
                                 @click.native="handleSchoolChange(item)" style="width: 100%;z-index: 9999;"/>
                    </el-select>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <FormItem label="详细地址" prop="detailAddress">
                    <Input v-model="edit.detailAddress" type="text" placeholder="请输入详细地址"
                           maxlength="100" :disabled="disabled"/>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <FormItem :label-width="110" label="报名开放日期" prop="signUpDate" required>
                    <Row>
                      <Col span="11">
                        <DatePicker :value="edit.signUpStartDate" :editable="false" @on-change="changeSignUpStartDate"
                                    type="date" format="yyyy-MM-dd" placeholder="开始日期" :disabled="disabled"/>
                      </Col>
                      <Col span="2" style="text-align: center">~</Col>
                      <Col span="11">
                        <DatePicker :value="edit.signUpEndDate" :editable="false" @on-change="changeSignUpEndDate"
                                    type="date" format="yyyy-MM-dd" placeholder="结束日期" :disabled="disabled"/>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </Col>
            <Col span="16">
            <!-- 右边内容区 -->
              <TaskTemplate ref="taskTemplate" :packagesNames="packagesNames" :applicable-age-list="applicableAgeList"
                          :taskProject="taskProjects" :packageDisabled="disabled" :itemDisabled="disabled" @setPackageId="setPackageId" style="margin-left: 10px;"/>
            </Col>
          </Row>
        </div>
    </IForm>

  </div>
</template>
<script>
import {_get, _save} from "@/services/task/task";
import TaskTemplate from "@/views/preScreening/task/TaskTemplate.vue";
import {mixins} from "@/mixins/index.js";
export default {
  name: "TaskEdit",
  components:{TaskTemplate},
  mixins: [mixins],
  data() {
    return {
      disabled:false,
      taskProjects:[],
      dialogImageUrl: '',
      dialogVisible: false,
      imgDisabled: false,
      edit: {
        name: "",
        physicalDate: "",
        crowdIds: "",
        schoolId: "",
        schoolName: "",
        detailAddress: "",
        signUpStartDate: "",
        signUpEndDate: "",
        signUpDate: "",
        packagesId:"",
        taskProject:[],
        status:1,
      },
      init: "",
      taskElem:[],
      taskRule: {
        name: [
          {required: true, message: '任务名称不能为空'},
          {maxlength:50,message:"任务名称长度不能超过50个字"}
        ],
        physicalDate: [
          {required: true, message: "请选择预计体检日期"}
        ],
        crowdIds: [
          {required: true, message: "请选择体检人群"}
        ],
        schoolId: [
          {required: true, message: "请选择体检地点"}
        ],
        signUpDate: [
          {validator:function(rule, value, callback){
              if (this.edit.signUpStartDate&&this.edit.signUpStartDate.length>0
                &&this.edit.signUpEndDate&&this.edit.signUpEndDate.length>0) {
                callback();
              } else {
                callback(new Error('请选择报名开放日期'));
              }
            }.bind(this), trigger: 'input' }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleSchoolChange(item) {
      this.edit.schoolId = item.id.toString();
      this.edit.schoolName = item.name;
    },
    changePhysicalDate(val){
      this.edit.physicalDate= val;
    },
    changeSignUpStartDate(val){
      this.edit.signUpStartDate = val;
      if(this.edit.signUpStartDate&&this.edit.signUpEndDate){
        this.edit.signUpDate = this.edit.signUpStartDate + "/" + this.edit.signUpEndDate;
      }else{
        this.edit.signUpDate = "";
      }
    },
    changeSignUpEndDate(val){
      this.edit.signUpEndDate = val;
      if(this.edit.signUpStartDate&&this.edit.signUpEndDate){
        this.edit.signUpDate = this.edit.signUpStartDate + "/" + this.edit.signUpEndDate;
      }else{
        this.edit.signUpDate = "";
      }
    },
    async handleModal(row) {
      await this.applySchoolsList();
      await this.applyCrowdList();
      await this.applyApplicableAgeList();
      await this.applyPackagesName();
      this.$refs.taskTemplate.packagePanelConfigs = [];
      this.taskProjects=[];

      this.$refs["formInline"].handleReset();
      if (!row) {
        this.disabled = false;
        this.handleCreate();
        this.$nextTick(()=>{
          this.$refs["taskTemplate"].addPanelConfig();
        });
      } else {
        this.disabled = true;
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
      this.edit.taskProject=[];
    },
    handleEdit(row) {
      const params = {taskId: row.id};
      _get(params).then(res =>{
        if (res.errcode === 1) {
          this.edit = Object.assign({}, res.data);
          this.edit.schoolId = this.edit.schoolId.toString();
          if(this.edit.signUpStartDate&&this.edit.signUpEndDate){
            this.edit.signUpDate = this.edit.signUpStartDate + "/" + this.edit.signUpEndDate;
          }

          if(!this.edit.taskProject||this.edit.taskProject.length===0){
            this.$nextTick(()=>{
              this.$refs["taskTemplate"].addPanelConfig();
            });
          }
          this.taskProjects = this.edit.taskProject;
          this.$forceUpdate();
        }
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    setPackageId(packageId){
      this.edit.packageId = packageId;
    },
    toSubmit() {
      let packagePanelConfigs = this.$refs.taskTemplate.packagePanelConfigs;
      let taskProject = [];
      if(!packagePanelConfigs || packagePanelConfigs.length === 0){
        this.$message.warning("请先选择套餐!");
        return;
      }

      let unChoose = false;
      packagePanelConfigs.forEach(item => {
        if (!item.search.packagesId || item.search.packagesId === '') {
          return;
        }
        if((!item.taskProjects||item.taskProjects.length===0)&&(!item.taskLisProjects||item.taskLisProjects.length===0)){
          unChoose = true;
        }else{
          taskProject.push({
            packagesId: item.packagesId,
            taskProjects: item.taskProjects,
            taskLisProjects: item.taskLisProjects
          });
          unChoose = false;
        }
      });
      if (taskProject.length === 0) {
        this.$message.warning("请先选择套餐!");
        return;
      }else if (unChoose) {
        this.$message.warning("请先选择体检项目或LIS项目");
        return;
      }
      this.edit.taskProject = JSON.stringify(taskProject);

      delete this.edit.signUpDate;
      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.taskProjects = [];
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>
.i-content-task {
  & .i-search-bar {
    display: flex;
    justify-content: space-between;
  }
  & .i-content-task {
    min-height: auto;
    & .ivu-card-body {padding: 0;}
  }

}

.demo-split {
  display: flex;
  gap: 10px;
  & .demo-split-left {flex: 1;}
  & .demo-split-right {
    position: sticky;
    top: 0px;
    max-height: 1000px;
    overflow-y: hidden;
  }
}

/deep/ .ivu-btn > .ivu-icon {line-height: 1.5;font-size: 18px;}
/deep/.ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.ivu-checkbox-disabled+span {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.el-input.is-disabled .el-input__inner {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.ivu-select-disabled .ivu-select-selection {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}

/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {background-color: #409EFF;border-color: #409EFF;}
/deep/ .ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;color: #515a6e;}
/deep/ .ivu-select-disabled .ivu-select-selection {background-color: #f3f3f38c;color: #515a6e;}
/deep/ .ivu-radio-disabled .ivu-radio-inner:after{  background-color: #409EFF;}

</style>
